import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CClassTribIbsCbsStruct } from '@shared/services/structs/motor-fiscal/c-class-trib-ibs-cbs.struct';
import { CstIbsCbsCclasstribIbsCbsStruct } from '@shared/services/structs/motor-fiscal/cst-ibs-cbs-cclasstrib-ibs-cbs.struct';
import { LookupItemStruct } from '@shared/services/structs/motor-fiscal/lookup-item.struct';

/**
 * Seção de classificação tributária (CST, cClassTrib e indDoacao do IBS/CBS).
 * O cClassTrib é filtrado pelo CST selecionado (regra UB14-20 da NT 2025.002,
 * exigida pela US 142894 §1) usando a relação carregada do catálogo; sem
 * relação cadastrada para o CST, mostra a lista completa (postura pouco
 * restritiva) em vez de travar o select.
 */
@Component({
    selector: 'app-regra-tributaria-classificacao-tributaria-section',
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, MatFormFieldModule, MatSelectModule, MatIconModule, MatTooltipModule],
    templateUrl: './regra-tributaria-classificacao-tributaria-section.component.html',
    styleUrl: './regra-tributaria-classificacao-tributaria-section.component.css',
})
export class RegraTributariaClassificacaoTributariaSectionComponent implements OnInit, OnChanges {
    @Input({ required: true }) form!: FormGroup;
    @Input() csts: CClassTribIbsCbsStruct[] = [];
    @Input() cclasstribs: CClassTribIbsCbsStruct[] = [];
    @Input() relacoes: CstIbsCbsCclasstribIbsCbsStruct[] = [];
    @Input() indicadoresDoacao: LookupItemStruct[] = [];

    public ngOnInit(): void {
        this.form.get('cstIbsCbs')?.valueChanges.subscribe(() => this.limparCclasstribSeInvalido());
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes['relacoes'] && this.form) this.limparCclasstribSeInvalido();
    }

    /** cClassTrib do catálogo compatíveis com o CST selecionado; sem relação cadastrada, mostra todos. */
    public get cclasstribsFiltrados(): CClassTribIbsCbsStruct[] {
        const cst = this.form?.get('cstIbsCbs')?.value;
        if (!cst) return this.cclasstribs;
        const codigosValidos = this.relacoes.filter(r => r.cstIbsCbs === cst).map(r => r.cclasstribIbsCbs);
        if (codigosValidos.length === 0) return this.cclasstribs;
        return this.cclasstribs.filter(c => codigosValidos.includes(c.codigo));
    }

    private limparCclasstribSeInvalido(): void {
        const control = this.form?.get('cclassTrib');
        const atual = control?.value;
        if (atual && !this.cclasstribsFiltrados.some(c => c.codigo === atual)) {
            control?.setValue(null);
        }
    }
}
